import { Navigate } from "react-router-dom";
import Utils from "../utility";
import {
  getUserNameFromLs,
  getUserTypeFromLs,
} from "../utility/commonFunction";
// import PrivateContainer from "../templates/PrivateContainer";
// import Utils from "../utils";

const PublicAuth = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  if (token?.length > 10) {
    if (["B", "PO"].includes(getUserTypeFromLs())) {
      // navigate("/store");
      return <Navigate to="/store" />;
    }
    if (
      Utils.constants.B2BUserAccess.includes(getUserNameFromLs()) ||
      getUserNameFromLs()?.slice(0, -1) == "category"
    ) {
      return <Navigate to="/b2b-po" />;
    } else return <Navigate to="/dashboard" />;
  }
  return <>{children}</>;
};

export default PublicAuth;
